// Auth/token constants extracted here to avoid circular dependency.
// `additiv-services/services/core/security` imports these, and `constants/constants`
// has UI-layer dependencies (ui-library) that would create a cycle if imported from there.

export const STATUS_OK = 200;

export const TokenScopes = {
    DFS_API: 'DfsApi',
    USER_AUTHENTICATION: 'openid profile DfsApi',
    NOTIFICATION_HUB_API: 'NotificationHubApi',
};

export const TokenGrantTypes = {
    GENERIC: 'generic',
    CLIENT_CREDENTIALS: 'client_credentials',
};

export const TokenTypes = {
    member_token: 'member_token',
    notification_hub_token: 'notification_hub_token',
    application_token: 'application_token',
    application_generic_token: 'application_generic_token',
};
